module.exports = __webpack_public_path__ + "media/packs/landing_page/images/studios/zuda-9b3734537f0660464f16f1e9153f9efd.png";